export const rules = {
    branch_id: [
        { required: true, message: 'Пожалуйста, введите отделения ', trigger: 'blur' },
    ],
    user_id: [
        { required: true, message: 'Пожалуйста, введите пользователь ', trigger: 'blur' },
    ],
};
